export default __webpack_public_path__ + "static/media/channels.40c86e14.png";